<template>
    <div class="modal">
      <div class="modal-wrapper">
        <div>
          <a class="close" v-on:click="$emit('close')"></a>
        </div>
        <div class="modal-form" v-if="!otc">
            <h1 v-html="$root.t(`loginform:title:${mode}`)"></h1>
            <form @submit="submit">
                <template v-if="mode === 'login'">
                    <div class="alert" v-html="$root.t(`loginform:infotext`)"></div>
                    <div class="extended_field">
                        <label v-html="$root.t('loginform:username')">
                        </label>
                        <input v-model="formdata.username" type="text" name="username">
                    </div>
                    <div class="extended_field">
                        <label v-html="$root.t('loginform:password')">
                        </label>
                        <input v-model="formdata.password" type="password" name="password">
                    </div>
                </template>
                <template v-if="mode === 'forgot' && !error">
                    <div class="extended_field">
                        <label v-html="$root.t('loginform:email')">
                        </label>
                        <input v-model="formdata.email" type="email" name="username">
                    </div>
                </template>
                <p v-if="error" class="modal-form-error" v-html="$root.t(`loginform:error:${error}`)"></p>
                <a class="decorated" v-on:click="mode = (mode == 'login' ? 'forgot' : 'login'); error = false"  v-html="$root.t(`loginform:mode:${(mode == 'login' ? 'forgot' : 'login')}`)"></a>

                <input type="submit" :value="$root.t('loginform:submit')">
            </form>
        </div>
        <div class="modal-form" v-else>
            <h1 v-html="$root.t(`loginform:title:new`)"></h1>
            <form @submit="submitnew">
                <template v-if="success">
                    <p v-if="error" class="modal-form-error" v-html="error"></p>
                </template>
                <template v-else>
                    <div class="extended_field">
                        <label v-html="$root.t('loginform:password')">
                        </label>
                        <input v-model="formdata.password_0" type="password" name="password0">
                    </div>
                    <div class="extended_field">
                        <label v-html="$root.t('loginform:password:again')">
                        </label>
                        <input v-model="formdata.password_1" type="password" name="password1">
                    </div>

                    <p v-if="error" class="modal-form-error" v-html="error"></p>

                    <input type="submit" :value="$root.t('loginform:submitnew')">
                </template>
            </form>
        </div>
      </div>
    </div>
</template>


<script>


export default {
  name: 'Loginform',
  props: ['otc'],
  data() {
      return {
          formdata: {
                username: "",
                password: ""
          },
          error: false,
          mode: 'login',
          success: false
      }
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      let result = await this.$store.dispatch('post', {
                          mode: `/${this.mode}`, 
                          params: this.formdata,
                          headers: {
                            'Content-type': 'application/json',
                          }
                      });
      if (result.error === true) {
          this.error = result.message;
      } 
      else {
        this.$root.logindata = result;
        this.$store.state.http.defaults.headers.common["X-LOGIN-KEY"] = this.$root.logindata.token;
        this.$store.state.rhttp.defaults.headers.common["X-LOGIN-KEY"] = this.$root.logindata.token;
        this.$root.loginCallback();
        this.$emit('close');
      }
      return false;
    },
    async submitnew(e) {
      e.preventDefault();
      if (this.formdata.password_0.length >= 8 && this.formdata.password_0 === this.formdata.password_1) {
        this.formdata.otc = this.otc;
        let result = await this.$store.dispatch('post', {
                            mode: '/setpass', 
                            params: this.formdata,
                            headers: {
                                'Content-type': 'application/json',
                            }
                        });
        this.error = this.$root.t(`loginform:${result.message}`);
        if (result.error === false) {
            this.success = true;
        }
      }
      else {
        this.error = this.$root.t('loginform:password:tooshort')
      }
      return false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.modal {
    position: fixed;
    z-index: 10000;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    display: flex;

    .close {
        position: absolute;
        right: $padding;
        top: $padding / 2;
    }
    .alert {
        @include smallfont;
        a {
            border-bottom: 1px solid;
        }
    }
    &-wrapper {
        max-width: $screen-sm-min;
        max-height: 100%;
        width: 100%;
        background: white;
        margin: auto;
        position: relative;
        padding-top: $padding;
        @include sm {
            height: 100%;
        }
    }
    &-form {
        padding: $padding;
        input {
            width: 100% !important;
            &[type="submit"] {
                margin-top: $padding * 2;
            }
        }
        &-error {
            color: $highlight-color;
        }
    }
}
</style>
